import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/resources")({
  head: () => buildRouteHead("/resources", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/resources", replace: true });
  },
});
